export default "__VITE_ASSET__JHt$8TF6__"